// Kiểm tra & mở cập nhật cho APP NATIVE (Capacitor). Web bỏ qua (web tự cập nhật khi F5).
import { Capacitor } from '@capacitor/core';
import { getAppVersion } from './api/app';

// Trả về { mandatory, versionName, url, notes } nếu CÓ bản mới cho nền tảng hiện tại; ngược lại null.
export async function checkAppUpdate() {
  if (!Capacitor?.isNativePlatform?.()) return null;
  const platform = Capacitor.getPlatform();

  let info;
  try {
    const { App } = await import('@capacitor/app');
    info = await App.getInfo(); // { version, build }  (build = versionCode trên Android)
  } catch { return null; }

  let data;
  try { data = await getAppVersion(); } catch { return null; }

  if (platform === 'android' && data && data.android) {
    const current = parseInt(info.build, 10) || 0;
    const latest = parseInt(data.android.versionCode, 10) || 0;
    if (latest > current) {
      return {
        mandatory: !!data.android.mandatory,
        versionName: data.android.versionName || '',
        url: data.android.url || '',
        notes: data.android.notes || '',
      };
    }
  }
  // iOS: TestFlight tự nhắc tester khi có build mới -> không tự dựng popup ở đây.
  return null;
}

// Mở link tải bản mới. Android: mở trình duyệt hệ thống để tải + cài APK.
export function openUpdate(url) {
  if (!url) return;
  try { window.open(url, '_system'); } catch { window.location.href = url; }
}
